<mat-checkbox type="checkbox" class="sg-floating-box mt-3" #mycheckbox [checked]="isChecked$ | async"
 (change)="toggleChecked()"></mat-checkbox>
 <!-- [indeterminate]="indeterminates" -->